import { request, GETApi, POSTApi, DELETEApi } from '../utils/request'
export const appReducer = request({
  reducerPath: 'app', endpoints: (builder) => {
    return {
      apiKeysList: GETApi(builder, '/webaccess/list'),//分页查询apiKeys信息
      addApp: POSTApi(builder, '/webaccess'),//根据webLicenseId新增Access应用
      updateApp: POSTApi(builder, '/webaccess/update'),//修改apiKeys
      deleteApp: DELETEApi(builder, '/webaccess'),//删除apiKeys
      tokenList: GETApi(builder, '/tokens/page'),//分页查询token信息
      hardWareList: GETApi(builder, '/host/page'),//分页查询token信息
    }
  }
})
export const {
  useLazyApiKeysListQuery,
  useLazyTokenListQuery,
  useAddAppMutation,
  useUpdateAppMutation,
  useDeleteAppMutation,
  useLazyHardWareListQuery,
} = appReducer